import type { IconSvgProps } from '../Icon.types';

export const ChevronDownSimple = ({ width, height }: IconSvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32">
      <path d="M26.53 12.53L16.53 22.53C16.3894 22.6704 16.1987 22.7493 16 22.7493C15.8012 22.7493 15.6106 22.6704 15.47 22.53L5.47 12.53C5.33752 12.3878 5.2654 12.1997 5.26882 12.0054C5.27225 11.8111 5.35096 11.6258 5.48838 11.4883C5.62579 11.3509 5.81118 11.2722 6.00548 11.2688C6.19978 11.2654 6.38782 11.3375 6.53 11.47L16 20.9387L25.47 11.47C25.6122 11.3375 25.8002 11.2654 25.9945 11.2688C26.1888 11.2722 26.3742 11.3509 26.5116 11.4883C26.649 11.6258 26.7277 11.8111 26.7312 12.0054C26.7346 12.1997 26.6625 12.3878 26.53 12.53Z" />
    </svg>
  );
};
